export async function loadExportClient() {
  const module = await import('@/export-api');
  return module.exportApiClient;
}
